// extracted by mini-css-extract-plugin
export var displayCount = "styles-module__displayCount___oCenD";
export var pushRight = "styles-module__pushRight___IHHlu";
export var selectCell = "styles-module__selectCell___PTsGr";